import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="transparent"
    stroke="currentColor"
    {...props}
  >
    <path d="M1.75 5.83333H12.25M1.75 8.16667H12.25M7 5.83333V10.5M2.91667 10.5H11.0833C11.7277 10.5 12.25 9.97767 12.25 9.33333V4.66667C12.25 4.02233 11.7277 3.5 11.0833 3.5H2.91667C2.27233 3.5 1.75 4.02233 1.75 4.66667V9.33333C1.75 9.97767 2.27233 10.5 2.91667 10.5Z" />
  </svg>
);
